<script setup lang="ts">
defineOptions({
	name: 'HeroSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="bg-primary-900 lg:min-h-[580px] flex flex-col items-center justify-center py-20 lg:py-0">
		<div class="container space-y-10 text-center">
			<div class="mx-auto w-fit">
				<div class="flex flex-col items-center justify-center">
					<p class="text-white text-sm font-semibold">{{ $t('Responsible Playing') }}</p>
					<div class="w-4/5 h-px bg-white" />
				</div>
			</div>

			<h1 class="text-3xl sm:text-6xl lg:text-[80px] text-white font-semibold !leading-tight lg:mx-10">
				{{ $t('Our Commitment to Your Fun and Well-being') }}
			</h1>
			<p class="text-[18px] sm:text-xl text-white sm:font-semibold">
				{{ $t('Your guide to a safer, smarter, and more enjoyable experience with luck') }}.
			</p>
		</div>
	</section>
</template>
